/*
 * slider/index.js
 *
 * This file contains the default setup for slick slider and provides a method to initlise new carousels
 * with these GS FED Boilerplate defaults. This component is designed to be included with other components, see usage
 * below:
 *
 * import slider from '../slider';
 *
 * let customOpts = { yourCustomOpts }
 * slider('.my-custom-slider-class', customOpts);
 *
 */
import $ from 'jquery';
import 'slick-carousel';

function homepageSlider() {
    const $component = $('.c-slider-homepage');

    // Init all the sliders on the page one at a time
    $component.each(function () {
        const $sliderContainer = $(this).children('.slider-container');
        const $slider = $(this).find('.inner');

        const slickDefaults = {
            mobileFirst: true,
            appendArrows: $sliderContainer,
            appendDots: $sliderContainer,
            infinite: true,
            autoplay: false,
            dots: true,
            speed: 500,
            autoplaySpeed: 5000,
            prevArrow: false,
            nextArrow: false,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 1023,
                    settings: { adaptiveHeight: false }
                }
            ]
        };

        $slider.slick(slickDefaults);
    });
}

export default homepageSlider;



// WEBPACK FOOTER //
// ./src/components/slider/c-slider-homepage.js